import { isBefore, isAfter } from 'date-fns';
import { i18n } from '@/main.js';

const timeZone = 'America/New_York';

// Function to fetch dates dynamically from i18n (ISO string with ET offset)
const getLocalizedDate = (key) => {
  const dateString = i18n.global.t(key);
  return new Date(dateString);
};

// Get the current ET time as a Date object
const getNowInET = () => {
  const now = new Date();
  // Get ET time as a string: "MM/DD/YYYY, HH:MM:SS"
  const etString = now.toLocaleString('en-US', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
  // Parse the ET string back to a Date object (in local time, but with ET values)
  // Format: "MM/DD/YYYY, HH:MM:SS"
  const [datePart, timePart] = etString.split(', ');
  const [month, day, year] = datePart.split('/');
  return new Date(`${year}-${month}-${day}T${timePart}`);
};

const routeGuard = (to, from, next) => {
  const now = getNowInET();
  const startDate = getLocalizedDate('program.startDate');
  const endDate = getLocalizedDate('program.endDate');

  if (isBefore(now, startDate)) {
    return to.name !== 'PreProgram' ? next({ name: 'PreProgram' }) : next();
  } else if (isAfter(now, endDate)) {
    return to.name !== 'PostProgram' ? next({ name: 'PostProgram' }) : next();
  } else {
    // Gate logic: Check if state gate is passed
    const gatePassed = sessionStorage.getItem('gatePassed') === 'true';
    if (!gatePassed && to.name !== 'Gate' && to.name !== 'Support' && to.name !== 'FAQ') {
      return next({ name: 'Gate' });
    }

    return to.name === 'PreProgram' || (gatePassed && to.name === 'Gate') ? next({ name: 'Home' }) : next();
  }
};

const startDatePT = new Date('2026-05-15T00:00:00');
const endDatePT = new Date('2026-07-30T23:59:59');

export { routeGuard, startDatePT, endDatePT };
